import { Button, Modal, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from "@chakra-ui/react";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { useForm } from "react-hook-form";
import { API_BASE_URL, BLUE_COLOR, FORM_SUBMITTING_TEXT, MODAL_OVERLAY_DARKNESS } from "../const";
import { useParkOptInStore } from "../stores/ParkOptInStore";
import { ContactFormLayout } from "./ContactFormLayout";
import { ModalFormWrapper, useGetDefaultFormValues, useSaveFormValues } from "./FormComponents";

export const ParkFormModal: React.FC<{ isOpen: boolean; onClose: () => void; parkId: string }> = ({
  isOpen,
  onClose,
  parkId,
}) => {
  const { saveFormData } = useSaveFormValues();
  const { email, phone, SMS, post } = useParkOptInStore(["email", "phone", "SMS", "post"]);

  const { mutate, isPending } = useMutation({
    mutationFn: (parkPackData) => {
      return axios.post(`${API_BASE_URL}/parkpack`, parkPackData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },
    onSuccess: () => onClose(),
  });

  const { defaultValues } = useGetDefaultFormValues();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues });

  const onSubmit = (data: any) => {
    saveFormData(data);

    const signUpToEmailValue = data.signUpToEmail ? "Y" : "N";

    const parkPackData = {
      ...data,
      optIn: signUpToEmailValue,
      park: Number(parkId),
      optInEmail: email ? "Y" : "N",
      optInSms: SMS ? "Y" : "N",
      optInPhone: phone ? "Y" : "N",
      optInPost: post ? "Y" : "N",
    };

    mutate(parkPackData);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay bg={MODAL_OVERLAY_DARKNESS} />
      <ModalContent borderRadius="10px" maxW="515px">
        <ModalHeader bg={BLUE_COLOR} textAlign="center" fontSize="28px" borderTopRadius="10px">
          Request Free Park Pack
        </ModalHeader>
        <ModalCloseButton size="md" />

        <ModalFormWrapper>
          <form onSubmit={handleSubmit(onSubmit)}>
            <ContactFormLayout register={register} errors={errors} />

            <Button
              variant="blue"
              type="submit"
              fontWeight="bold"
              borderRadius="20px"
              borderColor="gray.200"
              borderWidth="1px"
              mt="10px"
              w="100%"
              isDisabled={isPending}
            >
              {isPending ? FORM_SUBMITTING_TEXT : "Request Free Park Pack"}
            </Button>
          </form>
        </ModalFormWrapper>
      </ModalContent>
    </Modal>
  );
};
